const DEFAULTS = {
}

export default class Swatch {

  constructor (el, options) {
    this.options = options;
    this.$el = $(el)
    this.init();
  }

  /**
   * Register this component as global jquery plugin
   */
  static jqueryPlugin () {
    $.fn.comfSwatch = function (option) {
        var args = Array.prototype.slice.call(arguments, 1)
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('trueper.swatch')
            var options = $.extend({}, DEFAULTS, $this.data(), typeof option == 'object' && option)
            if (!data) $this.data('trueper.swatch', (data = new Swatch(this, options)))
            else if (typeof option == 'string') data[option].apply(data, args)
        })
    }
    $.fn.comfSwatch.Constructor = Swatch
    $('[data-control="swatch"]').comfSwatch();
  }

  init () {
    this.$product = this.$el.closest('.product')
    this.$thumb = this.$product.find('.loop-product-thumbnail')
    this.$anchor = this.$product.find('a.woocommerce-loop-product__link')
    this.$el.on('mouseenter', '.swatch-item', (e) => {
      let $swatch = $(e.currentTarget)
      let { thumbnail, permalink } = $swatch.data('swatch')
      this.$thumb.html(thumbnail)
      this.$anchor.attr('href', permalink)
      this.$product.find('.swatch-item').removeClass('is-active')
      $swatch.addClass('is-active')
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/components/swatch.js